<template>
    <div v-el:holder>
        <div style="width:100%;border:1px solid #ccc;background-color:#eee;margin-bottom: 10px; padding: 15px">
            <div>
                <slot></slot>
            </div>
            <dragster :enter="dragEntered" :leave="dragLeft">
                <div class="drop-zone"
                     @drop="ondrop"
                     @click="promptFiles"
                     :style="dropZoneStyle"
                     :class="{hovering: isHovering}">
                    <div style="min-height: 220px">
                        <div v-if="files.length < 1" style="left: 50%; top: 50%; position: absolute; transform: translateX(-50%);">
                            <a href="javascript:;">Clique aqui</a>
                            ou arraste imagens para adicionar
                            <i class="fa fa-info-circle"
                               title="Formatos suportados: JPG, JPEG e PNG <br/> Tamanho maximo: 10MB"
                               v-tooltip></i>
                        </div>
                        <table v-if="files.length > 0" class="table">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Tamanho</th>
                                    <th>Status</th>
                                    <th>Progresso</th>
                                    <th>Tempo</th>
                                    <th>Velocidade</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="file in files">
                                    <td>{{ file.name }}</td>
                                    <td>{{ file.size | fileSize }}</td>
                                    <td>
                                        <div style="position: relative">{{ statuses[file.status] }}</div>
                                    </td>
                                    <td width="210">
                                        <div class="progress" v-if="file.complete" style="margin-bottom: 0; width: 200px">
                                            <div class="progress-bar progress-bar-striped active"
                                                 role="progressbar"
                                                 :aria-valuenow="100"
                                                 aria-valuemin="0"
                                                 aria-valuemax="100"
                                                 style="width: 100%">
                                                Finalizando...
                                            </div>
                                        </div>
                                        <div class="progress" v-if="file.progress && !file.complete" style="margin-bottom: 0; width: 200px">
                                            <div class="progress-bar"
                                                 role="progressbar"
                                                 :aria-valuenow="Math.ceil(file.progress)"
                                                 aria-valuemin="0"
                                                 aria-valuemax="100"
                                                 :style="{width: file.progress + '%'}">
                                                {{ Math.ceil(file.progress) + '%' }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="!file.remainingTime || file.complete"> - </span>
                                        <span v-if="file.remainingTime && !file.complete">
                                            {{ file.remainingTime + 's' }}


                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="!file.downloadSpeed || file.complete"> - </span>
                                        <span v-if="file.downloadSpeed && !file.complete">
                                            <span v-if="file.downloadSpeed">{{ file.downloadSpeed | downloadSpeed }}</span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="info-circle-holder" style="padding-right: 15px; margin-bottom: 10px; font-size: 12px">
                        Formatos suportados: JPG, JPEG e PNG. Tamanho máximo: 10MB
                    </div>
                </div>
            </dragster>
        </div>
        <div v-if="invalidFiles.length">
            <h4><b>Informações</b></h4>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Tamanho</th>
                        <th>Motivo</th>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="file in invalidFiles" style="background-color: #ebcccc; color: #a94442">
                        <td>{{ file.name }}</td>
                        <td>{{ file.size | fileSize }}</td>
                        <td>{{ reasons[file.reason] }} <i class="fa fa-info-circle" :vtitle="reasonHint[file.reason]" v-tooltip></i></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <input type="file" multiple @change="inputChanged" v-el:files style="display: none;"/>
    </div>
</template>
<style scoped>
    .drop-zone {
        width: 100%;
        min-height: 255px;
        background-color: #f4f4f4;
        position: relative;
        border: 3px dashed #D0D0D0;
    }

    .drop-zone > .info-circle-holder {
        color: #777777;
        text-align: right;
    }

    .drop-zone .dropped-file {
        margin-bottom: 15px;
    }

    .drop-zone .dropped-file .upload-progress {
        position: absolute;
        font-size: 13px;
        width: 0;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: green;
        color: white;
        text-align: center;
        overflow: hidden;
        transition: all .5s ease-in;
    }
</style>
<script>
    const R = require('ramda')
    const resizer = require('sci/helpers/image-resizer')
    const { guid, client, vueChaos } = require('sci/helpers')
    const { mime } = require('sci/std')
    const Promise = require('bluebird')
    const PromiseQueue = require('promise-queue')

    PromiseQueue.configure(Promise)

    const uploadQueue = new PromiseQueue(2, Infinity)

    export default {
        name: 'new-dropzone',
        props: {
            url: {
                type: String,
                required: true
            },
            onSent: {
                type: Function
            }
        },
        components: {
            Dragster: require('./Dragster.vue')
        },
        data () {
            return {
                invalidFiles: [],
                files: [],
                statuses: [
                    'Enfileirado...',
                    'Compactando...',
                    'Enviando...',
                    'Enviado!',
                    'Enfileirado para envio...'
                ],
                reasons: [
                    'Formato inválido',
                    'Arquivo muito grande',
                    'Erro ao enviar',
                    'Arquivo rejeitado'
                ],
                reasonHint: [
                    'Algumas cameras ou softwares de manipulação<br /> de imagem podem salvar as imagens num formato<br /> reservado que não pode ser interpretados no momento.',
                    'O arquivo deve ter no máximo 10MB',
                    'Ocorreu um problema ao enviar o arquivo',
                    'O arquivo foi rejeitado pelo servidor'
                ],
                isHovering: false
            }
        },
        methods: {
            dragEntered (e) {
                this.isHovering = true
            },
            dragLeft () {
                this.isHovering = false
            },
            ondrop (evt) {
                this.isHovering = false
                evt.preventDefault()
                evt.stopPropagation()

                const newFiles = this.process(Array.prototype.slice.call(evt.dataTransfer.files))

                this.files = this.files.concat(newFiles)

                newFiles.forEach(_ => this.startUpload(_))
            },
            promptFiles () {
                this.$els.files.click()
            },
            inputChanged (evt) {
                const newFiles = this.process(Array.prototype.slice.call(evt.target.files))

                this.files = this.files.concat(newFiles)

                newFiles.forEach(_ => this.startUpload(_))

                evt.target.value = ''
            },
            validFile (file) {
                return /^image\/(png|jpeg|jpg)/.test(file.type) && (file.size < (10 * 1024 * 1024))
            },
            invalidReason (file) {
                if (!/^image\/(png|jpeg|jpg)/.test(file.type)) {
                    return 0
                }

                if (file.size >= (10 * 1024 * 1024)) {
                    return 1
                }

                return 0
            },
            process (files) {
                this.invalidFiles = this.invalidFiles.concat(files.filter(_ => !this.validFile(_)).map((x) => {
                    const uid = guid()

                    return {
                        guid: uid,
                        size: x.size,
                        type: x.type,
                        typeName: mime.fetch(x.type),
                        name: x.name,
                        thumbUrl: null,
                        status: 0,
                        reason: this.invalidReason(x),
                        $thumb: null,
                        $resized: null,
                        $original: x,
                        progress: 0,
                        remainingTime: 0,
                        spentTime: 0,
                        downloadSpeed: null,
                        complete: false
                    }
                }))

                return files.filter(this.validFile).map((x) => {
                    const uid = guid()

                    return {
                        guid: uid,
                        size: x.size,
                        type: x.type,
                        typeName: R.propOr('-', 'name', mime.fetch(x.type)),
                        name: x.name,
                        thumbUrl: null,
                        status: 0,
                        $thumb: null,
                        $resized: null,
                        $file: x,
                        $original: x,
                        progress: 0,
                        remainingTime: 0,
                        spentTime: 0,
                        downloadSpeed: null,
                        complete: false
                    }

                    //                    resizer.resize(uid, x, {
                    //                        'thumb': { maxWidth: 400, maxHeight: 400 },
                    //                        'original': { maxWidth: 1920, maxHeight: 1920 }
                    //                    }, () => {
                    //                        obj.status = 1
                    //                    }).then(({ uid, images: { thumb, original } }) => {
                    //                        this.thumbAvailable({
                    //                            uid,
                    //                            ...thumb
                    //                        })
                    //
                    //                        this.resizedAvailable({
                    //                            uid,
                    //                            ...original
                    //                        })
                    //
                    //                        this.startUpload(obj)
                    //                    })
                })
            },
            startUpload (obj) {
                uploadQueue.add(() => {
                    obj.status = 2

                    const data = new window.FormData()

                    data.append('file', obj.$file)

                    return client
                        .onProgress((percent, loaded, total, remaining, speed, remainingTime, spentTime) => {
                            obj.progress = percent
                            obj.remainingTime = remainingTime
                            obj.spentTime = spentTime
                            obj.downloadSpeed = speed
                            obj.complete = remaining <= 0
                        })
                        .post(`Enviando arquivo ${obj.name}`, this.url, data)
                        .then(vueChaos(this.$els.holder, false))
                        .then((response) => {
                            this.files.$remove(obj)

                            if (this.onSent) {
                                this.onSent(response.data, obj)
                            }
                        })
                        .catch((ex) => {
                            if (ex.statusCode === 400) {
                                obj.reason = 3
                            } else {
                                obj.reason = 2
                            }

                            this.files.$remove(obj)
                            this.invalidFiles.push(obj)
                        })
                })
            },
            setStatus (uid, status) {
                const item = R.find(R.propEq('guid', uid), this.files)

                item.status = status
            },
            thumbAvailable (x) {
                const item = R.find(R.propEq('guid', x.uid), this.files)

                item.$thumb = x
                item.thumbUrl = x.url
            },
            resizedAvailable (x) {
                const item = R.find(R.propEq('guid', x.uid), this.files)

                item.$resized = x
                item.size = x.file.size
            }
        },
        computed: {
            dropZoneStyle () {
                if (this.isHovering) {
                    return { opacity: 0.5 }
                }

                return {}
            }
        }
    }
</script>



// WEBPACK FOOTER //
// NewDropzone.vue?0547e4f1